import React from 'react';
import PortalV2Layout from './PortalV2Layout';
import JobRequestNew from '../JobRequestNew';
import { useAuth } from '../contexts/AuthContext';
import '../v2/v2.css';

/**
 * Submit New Job (V2) — embeds the public dark V2 /job-request form (JobRequestNew)
 * inside the V2 portal layout. Hides the "Existing Client?" banner and auto-prefills
 * Company / First / Last / Email / Phone from the logged-in user account.
 *
 * NOTE: We import v2.css and wrap with `.v2-root .v2-jobrequest` so the dark
 * editorial styling (CSS variables, form panels, inputs, headings) applies here —
 * matching the public /job-request page exactly.
 */
const ClientV2SubmitJob = () => {
  const { user } = useAuth();
  return (
    <PortalV2Layout
      eyebrow="Operations"
      title="Submit New Job"
      subtitle="Upload documents, enter recipient and case details, and get a confirmed quote."
      crumbs={<strong>Submit New Job</strong>}
    >
      <div className="v2-root pv2-jobrequest-portal" style={{ minHeight: 'auto', overflowX: 'visible', background: 'transparent' }}>
        <div className="v2-jobrequest" style={{ paddingTop: 0, background: 'transparent' }} data-testid="pv2-submit-job-wrap">
          <JobRequestNew hideExistingClientBanner prefillUser={user} />
        </div>
      </div>
    </PortalV2Layout>
  );
};

export default ClientV2SubmitJob;
